import { useState } from "react";
import { APIEndpoints } from "utils/APIEndpoints";
import sanitize from "utils/SanitizeHtml";
import Card from "react-bootstrap/Card";
import ArrowLink from "common/ArrowLink/ArrowLink";

const GuestCenter = ({ labels, resources }) => {
  const [activeProfile, setActiveProfile] = useState("rob");
  const videoUrl =
    labels?.learningCenter?.guestCenter?.guestCenterVideo;

  const openVideo = () => {
    window.open(videoUrl, "_blank", "noopener,noreferrer");
  };

  
  return (
    <section className="section-three pt-4 guestCenter">
      {/* Section One  */}
      <section className="row flex-between-center px-0 py-4">
        <div className="col-12 col-lg-7">
          <div className="header mb-3">
            {labels?.learningCenter?.guestCenter?.title}
          </div>
          <span className="fw-medium">
            {labels?.learningCenter?.guestCenter?.description1}
          </span>

          <ul>
            <li>{labels?.learningCenter?.guestCenter?.description2}</li>
            <li>{labels?.learningCenter?.guestCenter?.description3}</li>
            <li>{labels?.learningCenter?.guestCenter?.description4}</li>
          </ul>
        </div>

        <div className="col-12 col-lg-5 pt-3">
          <div className="video-container pt-3">
            <Card
              style={{
                width: "100%",
                maxWidth: "399px",
                aspectRatio: "16/9",
              }}
              className="video-card"
              onClick={openVideo}
            >
              <Card.Body className="p-0">
                <img
                  src={APIEndpoints.images(
                    localStorage.getItem("tenant"),
                    "guestCenter.jpg"
                  )}
                  alt="Watch the video"
                  className="video-thumbnail"
                />
              </Card.Body>
            </Card>
            {/* Watch the video text */}
            <div className="watch-video-link pt-2" onClick={openVideo}>
              {labels?.learningCenter?.guestCenter?.watchVideoText}
            </div>
          </div>
        </div>
      </section>

      <section className="row discover">
        <div className="discover-left">
          <div className="header pb-2 text-left">
            {labels?.learningCenter?.guestCenter?.heading2}
          </div>
          <div className="text">
            {labels?.learningCenter?.guestCenter?.discoverRightText}
          </div>
          <div className="mt-4">
            <ArrowLink
              link={labels?.learningCenter?.guestCenter?.downloadBrochureLink}
              text={labels?.learningCenter?.guestCenter?.downloadBrochureText}
              iconName={labels?.learningCenter?.resourceIconName}
              className="mb-2"
            />
          </div>
        </div>
        <div className="discover-right">
          
        </div>

        <div className="discover-badge">
          <img
            src={APIEndpoints.images(
              localStorage.getItem("tenant"),
              "infinity.png"
            )}
            alt="infinity"
            className="infinity"
          />
          <div
            dangerouslySetInnerHTML={sanitize(
              labels?.learningCenter?.guestCenter?.discoverBadgeText
            )}
          ></div>
        </div>
      </section>

      {/* Learn More  */}
      <section className="row learn-more py-4 px-0">
        <div className="header pt-3 pb-3 text-center">
          {labels?.learningCenter?.guestCenter?.action}
        </div>
        <div className="text text-center pb-2 mb-5">
          {labels?.learningCenter?.guestCenter?.retirementIsAway}
        </div>

        <div className="pb-4">
          <div className="row text-center mb-4 justify-content-center">
            {labels?.learningCenter?.guestCenter?.profiles?.map((p) => (
              <div
                className={`col-md-2 profile position-relative ${
                  activeProfile === p.id ? "active" : ""
                }`}
                key={p.id}
                onClick={() => setActiveProfile(p.id)}
              >
                <img
                  src={APIEndpoints.images(
                    localStorage.getItem("tenant"),
                    p.id + ".png"
                  )}
                  alt={p.name}
                  className={`rounded-circle mb-2 ${
                    activeProfile === p.id ? "show-border" : ""
                  }`}
                  width="150"
                  height="150"
                />
                <div className="title fw-bold mb-2">{p.name}</div>
              </div>
            ))}
          </div>

          <div className="p-4 card border-0">
            {labels?.learningCenter?.guestCenter?.stepsData?.[
              activeProfile
            ]?.map((step, index) => (
              <div className="d-flex align-items-start mb-4" key={index}>
                <div className="me-3">
                  <div className="red-colored number rounded-circle">
                    {index + 1}
                  </div>
                </div>

                <div>
                  {index == 3 && (
                    <img
                      src={APIEndpoints.images(
                        localStorage.getItem("tenant"),
                        activeProfile + "-power5.png"
                      )}
                      alt="rob"
                      width="220"
                      height="220"
                      className="float-end power5"
                    />
                  )}
                  <h5 className="red-colored">{step.title}</h5>
                  <div
                    dangerouslySetInnerHTML={sanitize(step.text)}
                    className={`${index > 2 ? "col-10" : "col-11"}`}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="row conditional-msg py-4">
        <div className="small">
          {labels?.learningCenter?.guestCenter?.conditionalMsg}
        </div>
      </div>
    </section>
  );
};

export default GuestCenter;
